import React from 'react'
import { TextInput } from '@/components/admin/atoms/inputs/TextInput'
import { IconButton } from '@/components/admin/atoms/actions/IconButton'
import { XIcon } from 'lucide-react'
import { Inline } from '@/components/admin/atoms/layout/Inline'

interface SearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: never
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value, onChange, placeholder = 'Search…',
}) => (
  <Inline gap="1" align="center">
    <TextInput
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      type="search"
    />
    {value && (
      <IconButton
        icon={<XIcon style={{ width: 16, height: 16 }} />}
        label="Clear search"
        onClick={() => onChange('')}
        size="xs"
      />
    )}
  </Inline>
)
